import { render, staticRenderFns } from "./Cantidad.vue?vue&type=template&id=c2052492&"
import script from "./Cantidad.vue?vue&type=script&lang=js&"
export * from "./Cantidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports